import type { FeedbackSentiment } from './feedbackConst';

export const orderedSentiment: FeedbackSentiment[] = [1, 2, 3];
